import { EmploymentDetails } from '@kanda-libs/ks-frontend-services';

import AddressManual from './components/AddressManual';
import EmploymentAddressFieldsProvider from './context';

import { EmploymentClassType } from '../../PrimaryEmployment/types';

export interface PrimaryEmploymentAddressFieldsProps {
  employmentStatus: Extract<
    EmploymentDetails['employment_status'],
    'employed' | 'self_employed'
  >;
  employmentClass: Extract<EmploymentClassType, 'primary'>;
}

export interface SecondaryEmploymentAddressFieldsProps {
  employmentStatus: Extract<
    EmploymentDetails['employment_status'],
    'employed' | 'self_employed'
  >;
  employmentClass: Extract<EmploymentClassType, 'secondary'>;
  index: number;
  arrayName: string;
}

export type EmploymentAddressFieldsProps =
  | PrimaryEmploymentAddressFieldsProps
  | SecondaryEmploymentAddressFieldsProps;

const EmploymentAddressFields: React.FunctionComponent<EmploymentAddressFieldsProps> =
  function (props) {
    return (
      <EmploymentAddressFieldsProvider {...props}>
        <AddressManual />
      </EmploymentAddressFieldsProvider>
    );
  };

export default EmploymentAddressFields;
